import { UserSaveUseCase } from '../../../../application';

export default class UserSaveService {

    async RequestData(event) {
        const data = await UserSaveUseCase(event);
        return data;
    }
}
